import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8', 
        'Authorization': ConstantsService.AUTH_TOKEN
    })    
};


@Injectable()
export class LunchpageService {

    constructor(private http: HttpClient) { }

    getInstructions(rootUrl:string, usercode: string, student_id:number, exam_id: number, streamvideo: number, theory2: number, phycho: number, theory3: number, theory4: number):Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id, streamvideo:streamvideo}, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
        } 
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id, streamvideo:streamvideo}, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
        } 
        else if(theory3 == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/theory3/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id, streamvideo:streamvideo,second_exam :theory4}, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            }  
        else if(theory4 == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/theory3/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id, streamvideo:streamvideo,second_exam :theory4}, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            }                    
        else
        {
            return this.http.post<any>(rootUrl+'question/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id, streamvideo:streamvideo}, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }                               
    }

    getmyDL(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'exam/adaptive/getDLList', {usercode:usercode, userid:userid, subuserid:subuserid, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getInstructionsAdaptive(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'exam/adaptive/instruction', {usercode:usercode, userid:userid, subuserid:subuserid, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    
}